import { render, staticRenderFns } from "./UserSearchBarComponent.vue?vue&type=template&id=c438daea&scoped=true"
import script from "./UserSearchBarComponent.vue?vue&type=script&lang=js"
export * from "./UserSearchBarComponent.vue?vue&type=script&lang=js"
import style0 from "./UserSearchBarComponent.vue?vue&type=style&index=0&id=c438daea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c438daea",
  null
  
)

export default component.exports